(function () {
/*
 * -----------------------------------------------------------------------------
 * input-round-decimals
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @kind component
 * @overview Rounds an inputs number value to specified decimals.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("input-round-decimals") === undefined) {
    class inputRoundDecimals extends HTMLElement {
        constructor(){
            super();
            this.input = this.querySelector("input");
            this.decimals = Number(!this.attributes["data-decimals"] ? 2 : this.attributes["data-decimals"].value);
            this.input?.addEventListener("change", this.updateEvent.bind(this));
        }
        updateEvent(event) {
            let currentValue = Number(event.target.value);
            let newValue = Number(this.roundValue(currentValue, this.decimals));
            if (newValue === currentValue) return;
            this.input.value = newValue;
            this.input.dispatchEvent(new Event("change"));
        }
        roundValue(number, decimals) {
            let signum = number >= 0 ? 1 : -1;
            return (Math.round(number * Math.pow(10, decimals) + signum * 0.0001) / Math.pow(10, decimals)).toFixed(decimals);
        }
    }
    customElements.define("input-round-decimals", inputRoundDecimals);
}



})();
